import { ShieldAlert, Inbox } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const REPORT_STATUSES = ["Baru Masuk", "Dalam Investigasi", "Terselesaikan", "Komunitas Ditangguhkan"];
const STATUS_BADGE = {
  "Baru Masuk": "bg-sky-100 text-sky-800",
  "Dalam Investigasi": "bg-amber-100 text-amber-800",
  "Terselesaikan": "bg-emerald-100 text-emerald-800",
  "Komunitas Ditangguhkan": "bg-rose-100 text-rose-800",
};

function ReportRow({ report, onUpdate }) {
  return (
    <div data-testid={`report-row-${report.id}`} className="bg-white rounded-2xl border border-slate-200 p-5">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <div className="flex flex-wrap items-center gap-2">
            <span className={`text-xs font-bold px-3 py-1 rounded-full ${STATUS_BADGE[report.status] || "bg-slate-100"}`}>{report.status}</span>
            <span className={`text-xs font-bold px-3 py-1 rounded-full ${report.severity === "Tinggi" ? "bg-rose-600 text-white" : "bg-amber-100 text-amber-800"}`}>Severity: {report.severity}</span>
            {report.anonymous && <span className="text-xs font-bold px-3 py-1 rounded-full bg-slate-800 text-white">Anonim</span>}
          </div>
          <p className="font-bold text-slate-900 mt-2">{report.category}</p>
          <p className="text-xs text-slate-500">{report.target_type}: <span className="font-semibold">{report.target_name}</span> · {new Date(report.created_at).toLocaleDateString("id-ID")}</p>
          <p className="text-sm text-slate-600 mt-2 leading-relaxed max-w-2xl">{report.description}</p>
          {!report.anonymous && report.contact && <p className="text-xs text-slate-400 mt-1">Kontak pelapor: {report.contact}</p>}
        </div>
        <Select value={report.status} onValueChange={(v) => onUpdate(report.id, v)}>
          <SelectTrigger data-testid={`report-status-select-${report.id}`} className="rounded-xl w-56"><SelectValue /></SelectTrigger>
          <SelectContent>{REPORT_STATUSES.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}</SelectContent>
        </Select>
      </div>
    </div>
  );
}

export default function ReportsTab({ reports, onUpdate }) {
  return (
    <>
      <div className="bg-slate-50 border border-slate-200 rounded-2xl p-4 mb-5 flex items-center gap-3">
        <ShieldAlert className="w-5 h-5 text-rose-600 shrink-0" />
        <p className="text-sm text-slate-600 leading-relaxed">
          Pusat Keamanan & Pengaduan. Laporan berkategori berat (penipuan/pelecehan) yang belum terselesaikan otomatis menangguhkan pendaftaran relawan organisasi terkait.
        </p>
      </div>
      {reports.length === 0 ? (
        <div className="text-center py-16 text-slate-400"><Inbox className="w-10 h-10 mx-auto mb-2" /> Belum ada laporan masuk.</div>
      ) : (
        <div className="space-y-4">
          {reports.map((r) => <ReportRow key={r.id} report={r} onUpdate={onUpdate} />)}
        </div>
      )}
    </>
  );
}
